module.exports = __webpack_public_path__ + "static/media/TGR.60c3f07d.png";